import { createRouter, createWebHistory } from 'vue-router'
import SayYes from '../components/SayYes.vue'
import SecretWord from '../components/SecretWord.vue'

const routes = [
  {
    path: '/',
    name: 'secretWord',
    component: SecretWord
  },
  {
    path: '/say-yes',
    name: 'sayYes',
    component: SayYes
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
